<template>
  <!-- 地图容器 -->
  <div class="map-main">
    <div v-if="common.isMobile() === false">
      <div class="map-close" @click="mapClose"> × </div>
    </div>
    <div v-else>
      <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
        <div  @click="mapClose">
          <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
        </div>
        <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('hotelLocation')}}</div>
      </div>
    </div>
    <div class="map-data" :style="mapStyle">
      <div id="coordinates"></div>
      <div class="map-frame">
        <div class="map-frame-center">
          <div class="map-hotel-img">
            <img :src="hotelImg.url" alt="">
          </div>
          <div class="map-hotel-info">
            <div class="map-hotel-name">{{hotel.hotelname}}</div>
            <div class="map-hotel-addr">{{hotel.hoteladdress}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publicHotelMap',
  props: {
    longitude: {
      type: String
    },
    latitude: {
      type: String
    },
    hotel: {
      type: Object
    },
    hotelImg: {
      type: Object
    }
  },
  data () {
    return {
      resetLongitude: this.longitude,
      resetLatitude: this.latitude,
      windowHeight: document.documentElement.clientHeight,
      windowWidth: document.documentElement.clientWidth,
      mapStyle: {}
    }
  },
  watch: {
    longitude (newnew, oldold) {
      console.log(newnew, oldold)
      this.resetLongitude = newnew
    },
    latitude (newnew, oldold) {
      console.log(newnew, oldold)
      this.resetLatitude = newnew
    }
  },
  mounted () {
    if (this.common.isMobile() === true) {
      this.mapStyle = {height: (parseInt(this.windowHeight) - 60) + 'px', width: '100%'}
    }
    setTimeout(() => {
      this.init()
      var bottom = document.getElementsByClassName('mapboxgl-control-container')
      bottom.display = 'none'
    }, 1000)
  },
  methods: {
    init () {
      this.mbgl.accessToken = this.common.MapBoxPublicKey // 申请的key
      // var coordinates = document.getElementById('coordinates')
      const map = new this.mbgl.Map({
        container: 'coordinates',
        style: 'mapbox://styles/mapbox/streets-v9',
        center: [this.resetLongitude, this.resetLatitude], // 设置地图中心
        zoom: 13, // 设置地图比例
        color: '#FFFFFF',
        draggable: true
      })
      // 建立一个标记点
      var marker = new this.mbgl.Marker({
        draggable: true,
        color: 'red',
        scale: 1
      })
      marker.setLngLat([this.resetLongitude, this.resetLatitude]).addTo(map)
      // map.addControl(new this.mbgl.MapboxGeocoder({
      //   accessToken: this.mbgl.accessToken
      // }))

      // 使用定位模块
      // map.addControl(new this.mbgl.GeolocateControl({
      //   positionOptions: {
      //     enableHighAccuracy: true
      //   },
      //   trackUserLocation: true,
      //   showUserLocation: true,
      //   zoom: 14
      // }))

      /*
      function onDragEnd () {
        var lngLat = marker.getLngLat()
        coordinates.style.display = 'block'
        coordinates.innerHTML = 'Longitude: ' + lngLat.lng + '<br />Latitude: ' + lngLat.lat
      }
      marker.on('dragend', onDragEnd)

      // 点击获取经纬度模块&点击标记点
      map.on('click', function (e) {
        // document.getElementById('info').innerHTML = JSON.stringify(e.point) + '<br />' + JSON.stringify(e.lngLat)
        marker.setLngLat([e.lngLat.lng, e.lngLat.lat]).addTo(map)
      })
      */
    },
    mapClose: function () {
      var submitInfo = {'click': 1}
      this.$emit('mapClose', submitInfo)
    }
  }
}

</script>

<style scoped>
@import url('https://api.tiles.mapbox.com/mapbox-gl-js/v0.44.2/mapbox-gl.css');
.map-main{
  width:100%;
  height:100%;
  position:fixed;
  top:0px;
  left:0px;
  background:black;
  padding: 0px 0px 50px;
  z-index: 10002;
  background-color: rgba(0,0,0,0.8);
}
.map-close{
  width: 95%;
  height: 10%;
  margin: 0 auto;
  font-size: 50px;
  color: white;
  text-align: right;
  cursor:pointer;
}
.map-data{
  width: 95%;
  height: 85%;
  margin: 0 auto;
  text-align: left;
  position: relative;
}
.map-data-mobile{width: 100%;height: 95%;}
.map-frame{
  position: absolute;
  width: 100%;
  height: 15%;
  top: 85%;
  z-index: 1001;
}
.map-frame-center{
  background: white;
  width: 40%;
  height: 90%;
  margin: 0 auto;
  margin-top: 7px;
  -webkit-box-shadow: -5px 0 12px rgb(0 0 0 / 40%);
  box-shadow: -5px 0 12px rgb(0 0 0 / 40%);
}
.map-hotel-img{
  width: 25%;
  height: 100%;
  float:left;
}
.map-hotel-img img{
  width:100%;
  height:100%;
}
.map-hotel-info{
  width: 70%;
  height: 100%;
  float:left;
  overflow: hidden;
  white-space: nowrap;
}
.map-hotel-info .map-hotel-name{
  font-size:20px;
  font-weight:400;
  line-height:40px;
  margin-left:10px;
}
.map-hotel-info .map-hotel-addr{
  font-size:15px;
  font-weight:400;
  line-height:40px;
  margin-left:10px;
}
#coordinates {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.marker {
  background-image: url('https://res.roompai.com/static/img/hotelsearch/img-icon.svg');
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.mapboxgl-popup {
  max-width: 200px;
}
.mapboxgl-popup-content {
  text-align: center;
  font-family: 'Open Sans', sans-serif;
}

@media only screen and (max-width:967px){
  .map-frame-center{width:95%;}
}
@media only screen and (min-width:968px){

}
</style>



// WEBPACK FOOTER //
// src/components/public/publicHotelMap.vue